import { AuthService } from './../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';

@Injectable()
export class UserLoggedInResolve implements Resolve<any> {

  constructor(
    private _authService: AuthService,
    private _registryFirebaseService: RegistryFirebaseService,
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const pageUserMode = route.data.pageUserMode;
    const registryName = route.paramMap.get('registry');
    if (location.pathname.includes('/contribution-success')) {
      
      return Observable.of(false);
    }
    if (location.pathname.includes('/your-registry')) {
      return Observable.of(true);
    }
    if (pageUserMode == 'couple') {
      return this._authService.user.take(1)
        .map(x => {
          if (x) {

            return true;
          } else {
            return false;
          }
        });

    }


  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-logged-in.resolve.ts